export default __webpack_public_path__ + "static/media/image-phone-and-keyboard.fad0ac14.jpg";